import { CostEvent } from "src/api/generated/erp/db/types/tables/costEvent.ts";
import { CostEventFormApi_InitData } from "src/api/generated/erp/common/costEvents/api/costEventFormApi.ts";
import { FormSelectField } from "../../../../common/forms/fields/FormSelectField.tsx";
import i18n from "i18next";
import { FormTextField } from "../../../../common/forms/fields/FormTextField.tsx";
import { requireRule } from "../../../../common/forms/validation.ts";
import { FormDateField } from "../../../../common/forms/fields/FormDateField.tsx";
import { FormNumberField } from "src/components/common/forms/fields/FormNumberField.tsx";
import { AavoFormContentParams } from "../../../../common/forms/AavoForm.tsx";
import dayjs, { Dayjs } from "dayjs";
import { CostEventPriceListLine } from "../../../../../api/generated/erp/db/types/tables/costEventPriceListLine.ts";
import { findPriceListLineForCostEventItem } from "./CostEventFormContent.utils.ts";

export interface CostEventFormContentProps {
	control: AavoFormContentParams<CostEvent>["control"];
	setValue: AavoFormContentParams<CostEvent>["setValue"];
	watch: AavoFormContentParams<CostEvent>["watch"];
	initData: CostEventFormApi_InitData;
	setStoredItemId: (itemId: number | undefined) => void;
	autoFocusQuantity?: boolean;
}

export const CostEventFormContent = ({
	control,
	setValue,
	watch,
	initData,
	setStoredItemId,
	autoFocusQuantity = true,
}: CostEventFormContentProps) => {
	return (
		<>
			<FormSelectField
				control={control}
				name={"itemId"}
				label={i18n.t("item")}
				options={initData.availableCostEventItems}
				rules={requireRule()}
				getOptionKey={(o) => o.costEventItemId}
				getOptionLabel={(o) => o.itemName}
				onChange={(newItemId) => {
					setStoredItemId(newItemId ?? undefined);
					prefillCostPriceFromPriceList({
						itemId: newItemId ?? null,
						eventDate: dayjs(watch("eventDate")),
						priceListLines: initData.priceListLines,
						setValue,
					});
				}}
			/>
			<FormNumberField
				control={control}
				name={"quantity"}
				label={i18n.t("quantity")}
				rules={requireRule()}
				autoFocus={autoFocusQuantity}
			/>
			<FormDateField
				control={control}
				name={"eventDate"}
				label={i18n.t("date")}
				rules={requireRule()}
				disableClearable
				onChange={(newDate) => {
					prefillCostPriceFromPriceList({
						itemId: watch("itemId") ?? null,
						eventDate: newDate,
						priceListLines: initData.priceListLines,
						setValue,
					});
				}}
			/>
			<FormTextField control={control} name={"description"} label={i18n.t("description")} />
			<FormNumberField control={control} name={"cost"} label={i18n.t("cost")} />
			<FormNumberField control={control} name={"price"} label={i18n.t("price")} />
			<FormTextField control={control} name={"explanation"} label={i18n.t("explanation.cost_event")} />
		</>
	);
};

function prefillCostPriceFromPriceList({
	itemId,
	eventDate,
	priceListLines,
	setValue,
}: {
	itemId: number | null;
	eventDate: Dayjs;
	priceListLines: CostEventPriceListLine[];
	setValue: AavoFormContentParams<CostEvent>["setValue"];
}): void {
	const line = findPriceListLineForCostEventItem({ itemId, eventDate, priceListLines });
	if (line != null) {
		setValue("cost", line.cost);
		setValue("price", line.price);
	}
}
